// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iASWe","clinicsSelect":"styles_clinicsSelect__1SjuQ"};